import AssetPath from "../../AssetPath/AssetPath";

const partners = {
  Gold: [
    {
      Title: "Chryselys",
      image: AssetPath.partners.chryselys,
      linkedin: "https://www.linkedin.com/company/chryselys/",
      website: "https://chryselys.com/",
    },
  ],
  Silver: [
    {
      Title: "Defintive Healthcare",
      image: AssetPath.partners.defintiveHealthcare,
      linkedin:
        "https://www.linkedin.com/company/definitive-healthcare/?originalSubdomain=in",
      website: "https://www.definitivehc.com/",
    },
  ],
  Exhibit: [
    {
      Title: "Agilisium Consulting",
      image: AssetPath.eventPartners.Agilisium,
      linkedin: "https://www.linkedin.com/company/agilisium",
      website: "https://www.agilisium.com/",
    },
    {
      Title: "KMK",
      image: AssetPath.eventPartners.Kmk,
      linkedin: "https://www.linkedin.com/company/kmk-consulting-inc-",
      website: "https://kmkconsultinginc.com",
    },
    {
      Title: "Rosenblatt lifescience",
      image: AssetPath.eventPartners.RosenblattLifescience,
      linkedin:
        "https://www.linkedin.com/company/rosenblatt-life-science-consulting/",
      website: "https://rlsconsultants.com/",
    },
    {
      Title: "Tellius",
      image: AssetPath.eventPartners.tellius,
      linkedin: "https://www.linkedin.com/company/tellius",
      website: "https://www.tellius.com/",
    },
    {
      Title: "ZS",
      image: AssetPath.partners.zs,
      linkedin: "https://www.linkedin.com/company/zs-associates/",
      website: "https://www.zs.com/",
    },
  ],
};

export default function EventPartners({ className }) {
  return (
    <section className={`our-partners event-partners spacing-top ${className}`}>
      <div className="container">
        <h4
          className="text-center mb-2 h3 text-primary fw-bold"
          data-aos="fade-up"
        >
          Event Partners
        </h4>
        <div className="row">
          {/* Gold and Silver Partners */}
          {["Gold", "Silver"].map((category, index) => (
            <div key={index} className="col-12 col-md-12 mb-5">
              <div className="details card position-relative p-0">
                <div
                  className={`d-inline category-name ${category.toLowerCase()} mb-3`}
                >
                  <h5 className="text-center text-uppercase text-white mb-0">
                    {category} Partners
                  </h5>
                </div>
                <div className="row justify-content-center">
                  {partners[category].map((data, i) => (
                    <div
                      key={i}
                      className="col-6 col-sm-6 col-md-3 d-flex justify-content-center"
                    >
                      <a href={data.website} target="_blank" rel="noreferrer">
                        <img
                          src={data.image}
                          alt={data.Title}
                          title={data.Title}
                          className="partner-logo img-fluid"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}

          {/* Exhibit Partners */}
          <div className="col-12 mb-5">
            <div className="details card position-relative p-0">
              <div className={`d-inline category-name exhibit mb-3`}>
                <h5 className="text-center text-uppercase text-white mb-0">
                  Exhibit Partners
                </h5>
              </div>
              <div className="row justify-content-center">
                {partners.Exhibit.map((data, i) => (
                  <div
                    key={i}
                    className="col-6 col-sm-6 col-md-4 mb-3 d-flex justify-content-center"
                  >
                    <a href={data.website} target="_blank" rel="noreferrer">
                      <img
                        src={data.image}
                        alt={data.Title}
                        title={data.Title}
                        className="partner-logo img-fluid"
                      />
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
